
export const options = {

    fieldOptions: {
        beforeValidation:       [],
        focusOnRelated:         true,
        maxFileSize:            10
    }
    
}
